import React from 'react';
import PropTypes from 'prop-types';

import * as actions from '../actions';

import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import NumberFormat from 'react-number-format';

import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withTranslation } from 'react-i18next';

import {validate4} from './validate';
import ButtonValidation from './button_validation';

const numberSeparator = ' ';

const styles = theme => ({
  textField: {
    width: '100%',
  },
  formControlLabel: { 
  	marginLeft: '0',
		fontSize: '1rem', 
   '& label': { fontSize: '1rem' } 
  },
  grid:{
    paddingTop:'0px !important',
    paddingBottom:'0px !important'
  },
   gridTopOnly:{
    paddingTop:'0px !important',
  },
   title:{
    fontWeight: 'bold',
    marginBottom:theme.spacing.unit
  }
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator={numberSeparator}
    />
  );
}
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

function renderTextField(props) {
  const { input, classes, currency, label, meta: { touched, error } } = props;

  var value = ''
  if (input && input.value ){
    if( input.value.target && input.value.target.value ){
      value = input.value.target.value;
    }
    else {
      value = input.value;
    }
    if (value !== '' ){
      value = Number(value.toString().split(numberSeparator).join(""));
    }
  }
  return (
      <TextField
        {...input}
        label={label}
        className={classes.textField}
        margin="normal"
        variant="outlined"

        value={value}
        onChange={input.onChange(value)}

        InputProps={{
          endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
          inputComponent: NumberFormatCustom,
        }}
      />
  );
}

renderTextField.propTypes = {
  classes: PropTypes.object.isRequired,
};

function renderSwitch(props) {
  const {input,  label, classes, meta: { touched, error }, ...custom } = props;
  return (
  	<FormControlLabel
  		className={classes.formControlLabel}
      control={
        <Switch
        checked={input.value ? true : false}
        onChange={input.onChange}
        color="primary"
        />
      }
      label={<Typography style={{fontWeight: 'bold', fontSize: '1rem', '& label': { fontSize: '1rem' }}}>{label}</Typography>}
      labelPlacement="start" 
    /> 
   );
}


class FormEstimationFinancials extends React.Component {

	render() {	
    const { handleSubmit, classes, formUse, styles, t} = this.props;	

    var currency='';
    if (formUse && formUse.values){
      if (formUse.values.currency && formUse.values.currency.value){
      currency = formUse.values.currency.value;
      }
      if (formUse.values.ownerRealEstate === undefined ){
        this.props.submitFormEstimationInitialize();
      }
    }
	
	  return (
      <form onSubmit={handleSubmit}>   
        <Typography variant="h5" className={classes.title}>{t('financy')}</Typography>
				<Grid container spacing={8}>
          <Grid item xs={12} className={classes.gridTopOnly}>
						<Field
									label={t('financy')}
									name='cash'
									component={renderTextField}	
									currency={currency}
									classes={classes}
						/>
					</Grid>
          <Grid item xs={12}>
        		<ButtonValidation 
                activeStep = {this.props.activeStep}
                handleBack = {this.props.handleBack} 
                steps  = {this.props.steps}
                invalid = {this.props.invalid}
            />
          </Grid>
        </Grid>
      </form> 
		);
	}
}

FormEstimationFinancials = reduxForm({ 
	form: 'formEstimation',
	destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate: validate4
  })(FormEstimationFinancials);

function mapStateToProps(state){
	return { 
		formUse: state.form.formEstimation,
	};
}


FormEstimationFinancials.propTypes = {
  classes: PropTypes.object.isRequired,
};
FormEstimationFinancials =  withStyles(styles)(FormEstimationFinancials);

export default connect(mapStateToProps, actions)(withTranslation()(FormEstimationFinancials));
